import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-simple-layout',
    templateUrl: 'simple-layout.component.html'
})

export class SimpleLayoutComponent implements OnInit {
    constructor() { }

    ngOnInit() { }
}



// WEBPACK FOOTER //
// ./src/app/layouts/simple-layout.component.ts